import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  HostListener,
  ViewChild,
  ElementRef,
  AfterViewInit,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DeleteModalComponent } from 'src/app/modals/delete-modal/delete-modal.component';
import { PlaylistsService } from 'src/app/services/playlists.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
})
export class GridComponent implements OnInit {
  @Output() scrolled = new EventEmitter<null>();
  @Output() refreshDelete = new EventEmitter<null>();
  @ViewChild('container') container!: ElementRef;
  @Input() items: Array<any> = [];
  @Input() cols = 3;
  @Input() courseCompleted = false;
  @Input() colsMd = 2;
  @Input() language = 'en';
  @Input() type = '';
  @Input() clickItem: number | null = null;
  @Input() group: any = null; // for lists inside a group
  @Input() isFromGroup: boolean = false;
  colSize = 4;
  colSizeMd = 6;

  constructor(
    private toastService: ToastService,
    private ngbModal: NgbModal,
    private playlistService: PlaylistsService
  ) {}

  ngOnInit(): void {
    this.colSize = 12 / this.cols;
    this.colSizeMd = 12 / this.colsMd;
  }

  getRefresh() {
    this.refreshDelete.emit();
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(e: any) {
    let bottomPosition =
      this.container.nativeElement.getBoundingClientRect().top +
      this.container.nativeElement.offsetHeight;
    if (bottomPosition < window.innerHeight) {
      this.scrolled.emit();
    }
  }

  public deleteItem($event: any,type : string) {

    let textTitle: string = 'playlist:edit:delete'
    let textMessaje:string = 'groups:profile:playlists:delete:modal:text'
    if (type =='playlist') {
      textTitle =  'playlist:edit:delete';
      textMessaje =  'groups:profile:playlists:delete:modal:text';
    }
    if (type =='video') {
      textTitle =  'groups:profile:video:delete:modal:title';
      textMessaje =  'groups:profile:video:delete:modal:text';
    }
    if (type =='course') {
      textTitle =  'groups:profile:courses:delete:modal:title';
      textMessaje =  'groups:profile:courses:delete:modal:text';
    }
    let modalRef = this.ngbModal.open(DeleteModalComponent, {
      windowClass: 'default-modal',
      size: '600',
      centered: false,
    });
    modalRef.componentInstance.title =textTitle;
    modalRef.componentInstance.message = textMessaje;
    modalRef.componentInstance.response.subscribe((data: any) => {
      if ((data = 'yes')) {
        this.playlistService
          .deleteFromGroup($event, this.group)
          .then((resp: any) => {
            if (resp.result == 'success') {
              this.toastService.showSuccess('Successfully deleted');
              this.refreshDelete.emit($event);
            } else {
              this.toastService.showError('Something went wrong deleting');
            }
          })
          .catch((resp: any) => {
            this.toastService.showError('Something went wrong deleting');
          });
      } else {
        console.log('no');
      }
    });
  }
}
